import { styled } from '@mui/material';
import { corePalette } from '@/themes/colours';

export const MarkerDot = styled('span')({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  boxShadow: `0 0 0 0.5px ${corePalette.grey10}`,
  flexShrink: 0,
  transition: 'transform 150ms ease, box-shadow 150ms ease',
});

export const MarkerStackDot = styled('span')({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  boxShadow: `0 0 0 0.5px ${corePalette.grey10}`,
  marginTop: '-3px',
  flexShrink: 0,
  transition: 'transform 150ms ease, box-shadow 150ms ease',
});

export const ParentDrop = styled('svg')({
  flexShrink: 0,
  display: 'block',
  borderRadius: '50%',
  overflow: 'visible',
});
